<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <div class="headTab d-flex align-items-center">
          <h1
            class="page-name"
            [ngClass]="{ active: !isMyTab }"
            (click)="switchTab(false)"
          >
            Available Leads
          </h1>
          <h1
            class="page-name"
            [ngClass]="{ active: isMyTab }"
            (click)="switchTab(true)"
          >
            My Leads
          </h1>
        </div>
        <div class="price-top-m">
          <p
            class="price-sub"
            data-toggle="modal"
            data-target="#year_selection"
          >
            <span>$ {{ leads.totalPay | number }}</span>
            <i
              class="fa fa-caret-down"
              aria-hidden="true"
              *ngIf="leads.totalPay > 0"
            ></i>
          </p>

          <div class="year-selection-m" *ngIf="leads.totalPay > 0">
            <!-- Modal -->
            <div
              class="modal fade"
              id="year_selection"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Total : $ {{ leads.totalPay | number }}
                  </h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p">
                      <li *ngFor="let paymentPart of leads.dispositionTotal">
                        <ng-container *ngIf="paymentPart.status >= 0">
                          <label
                            [title]="
                              totalPaymentSearch(
                                paymentPart.status,
                                despositionArray
                              )
                            "
                            >{{
                              totalPaymentSearch(
                                paymentPart.status,
                                despositionArray
                              )
                            }}</label
                          >
                          <span>$ {{ paymentPart.totpay | number }}</span>
                        </ng-container>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input
                type="text"
                name="search"
                [(ngModel)]="searchParams.emailId"
                (change)="rerender()"
                placeholder="Search by Order ID, Email or Phone"
              />
              <i
                class="fa fa-search"
                aria-hidden="true"
                (change)="rerender()"
              ></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input
                (onHidden)="splitFromTo()"
                [(ngModel)]="fullRangeDate"
                type="text"
                placeholder="Date Range"
                bsDaterangepicker
                [bsConfig]="{ isAnimated: true, showWeekNumbers: false }"
              />
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                  fill="#1C212D"
                />
                <path
                  d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z"
                  fill="#1C212D"
                />
                <path
                  d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z"
                  fill="#1C212D"
                />
                <path
                  d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z"
                  fill="#1C212D"
                />
                <path
                  d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z"
                  fill="#1C212D"
                />
                <path
                  d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z"
                  fill="#1C212D"
                />
                <path
                  d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z"
                  fill="#1C212D"
                />
                <path
                  d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z"
                  fill="#1C212D"
                />
                <path
                  d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z"
                  fill="#1C212D"
                />
                <path
                  d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z"
                  fill="#1C212D"
                />
                <path
                  d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z"
                  fill="#1C212D"
                />
                <path
                  d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z"
                  fill="#1C212D"
                />
                <path
                  d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z"
                  fill="#1C212D"
                />
                <path
                  d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z"
                  fill="#1C212D"
                />
                <path
                  d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z"
                  fill="#1C212D"
                />
              </svg>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m select-site-link">
              <ng-select
                [items]="siteList"
                bindLabel="abbr"
                bindValue="site_link"
                placeholder="Select Site Link"
                [(ngModel)]="searchParams.site_link"
                [ngModelOptions]="{ standalone: true }"
                [searchable]="false"
                [clearable]="true"
                appendTo=".top-section"
                (change)="rerender()"
              >
                <!-- <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.site_link }}
                </ng-template> -->
              </ng-select>
              <!-- <input type="text" name="search" [(ngModel)]="searchParams.site_link" (change)="rerender()" placeholder="Search by Site Link"> -->
              <!-- <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i> -->
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="despositionArray"
                bindLabel="name"
                bindValue="value"
                placeholder="Disposition type"
                [(ngModel)]="searchParams.disposition"
                [ngModelOptions]="{ standalone: true }"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
              >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter" *ngIf="!isMyTab">
            <div class="fields-m select-m multi-select">
              <ng-select
                [items]="agents"
                bindLabel="name"
                multiple="true"
                bindValue="id"
                placeholder="Agent Name"
                [(ngModel)]="searchParams.agent_id"
                [ngModelOptions]="{ standalone: true }"
                [searchable]="true"
                [clearable]="true"
                [closeOnSelect]="false"
                (change)="rerender()"
              >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <input
                    [checked]="searchParams.agent_id.indexOf(item.id) > -1"
                    type="checkbox"
                  />
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z"
                  fill="#1C212D"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div
        class="alert alert-info alert-dismissible fade show"
        role="alert"
        *ngIf="limitExceeded"
      >
        <p>Already working on too many leads.</p>
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="table-responsive">
        <table
          class="row-border hover"
          datatable
          [dtOptions]="dtOptions"
          [dtTrigger]="dtTrigger"
        >
          <thead>
            <tr>
              <th>Lead ID</th>
              <th>Timestamp</th>
              <th>Client Info</th>
              <th>Price / No. of Pages</th>
              <th>Academic Level</th>
              <th>Document Type</th>
              <th>Due Date</th>
              <th>Disposition</th>
              <th>Last Agent</th>
              <th>Action</th>
              <th>Follow Up</th>
              <th>Note for Self</th>
              <th>Comments</th>
            </tr>
          </thead>

          <!-- for Portal_Sales -->
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td class="id">
                  <ng-container *ngIf="lead.form_id !== 'facebook'">
                    {{ siteAbbr[lead.site_link] + "-" + lead.id }}
                  </ng-container>
                  <ng-container *ngIf="lead.form_id === 'facebook'">
                    {{
                      lead.form_id === "facebook" &&
                        "FB" + "-" + siteAbbr[lead.site_link] + "-" + lead.id
                    }}
                  </ng-container>
                  <div *ngIf="lead.first_assign_date">
                    <ng-container
                      *ngIf="
                        !getAssignTimer(lead.date, lead.first_assign_date)
                          .isGreen
                      "
                    >
                      <span
                        class="assign_timer_red"
                        [title]="
                          getAssignTimer(lead.date, lead.first_assign_date)
                            .tooltip
                        "
                      >
                        Late Assigned
                      </span>
                    </ng-container>
                  </div>
                </td>
                <td>
                  <p *ngIf="lead.date">{{ lead.date | date }}</p>
                  <p>{{ lead.date | date : "shortTime" }}</p>
                </td>
                <td>
                  <p [title]="lead.name">{{ lead.name }}</p>
                  <p [title]="lead.phone">{{ lead.phone }}</p>
                  <p [title]="lead.email">{{ lead.email }}</p>
                </td>
                <td>
                  <p class="price-td">$ {{ lead.price }}</p>
                  <p class="page-td">{{ lead.pages }} Pages</p>
                </td>
                <td>
                  <p [title]="lead.level">{{ lead.level | capitalize }}</p>
                </td>
                <td>
                  <p [title]="lead.work_type">
                    {{ lead.work_type | capitalize }}
                  </p>
                </td>
                <td>
                  <p *ngIf="lead.due_date == '0000-00-00 00:00:00'">-</p>
                  <ng-container *ngIf="lead.due_date != '0000-00-00 00:00:00'">
                    <p>{{ lead.due_date | date }}</p>
                    <p>{{ lead.due_date | date : "shortTime" }}</p>

                    <p
                      [ngClass]="{
                        'time-elapsed': lead.show_red,
                        'time-left': !lead.show_red
                      }"
                      *ngIf="lead.time_remaining"
                    >
                      {{ lead.time_remaining }}
                    </p>
                  </ng-container>
                </td>

                <!-- Disposition Td -->
                <td>
                  <div class="pos-rel" *ngIf="isMyTab">
                    <div
                      class="fields-m disposition-open select-m"
                      *ngIf="!lead.loadingComms"
                    >
                      <ng-select
                        [items]="despositionArray"
                        placeholder="Disposition type"
                        [(ngModel)]="lead.status"
                        [ngModelOptions]="{ standalone: true }"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="value"
                        (ngModelChange)="openChangeDesposition(lead, indx)"
                      >
                        <ng-template
                          ng-option-tmp
                          let-item="item"
                          let-index="index"
                        >
                          {{ item.name }}
                        </ng-template>
                      </ng-select>
                    </div>

                    <!-- Action Loader -->
                    <i
                      class="fa fa-spinner fa-spin"
                      *ngIf="lead.loadingComms"
                    ></i>
                    <span
                      class="late-disposed"
                      *ngIf="
                        isLateDisposed(
                          lead.first_assign_date,
                          lead.first_disposition_date_change
                        )
                      "
                    >
                      Late Disposed
                    </span>
                    <!-- Popup -->
                    <div class="notesModal mainModal qa-lead">
                      <div
                        class="modal fade"
                        [id]="'commentsLeadsModal' + indx"
                        tabindex="-1"
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog" role="document">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title text-left">
                              Add Lead Comment
                            </h5>
                          </div>
                          <!-- 📅 Date Field -->

                          <div class="modal-content">
                            <div class="modal-body">
                              <form [formGroup]="addCommentForm">
                                <div class="formItem shadowed w-100">
                                  <textarea
                                    [(ngModel)]="notes"
                                    formControlName="comment"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && f.comment.errors
                                    }"
                                    placeholder="Add comments."
                                  ></textarea>
                                </div>
                                <div
                                  class="formItem shadowed w-100 mt-3"
                                  *ngIf="salesStatusVal == 8"
                                >
                                  <input
                                    type="date"
                                    formControlName="commentDate"
                                    [min]="todayDateString"
                                    class="form-control"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && f.commentDate?.errors
                                    }"
                                    placeholder="Select date"
                                  />
                                </div>

                                <!-- ⏰ Time Field -->
                                <div
                                  class="formItem shadowed w-100 mt-3"
                                  *ngIf="salesStatusVal == 8"
                                >
                                  <input
                                    type="time"
                                    formControlName="commentTime"
                                    class="form-control"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && f.commentTime?.errors
                                    }"
                                    placeholder="Select time"
                                  />
                                </div>
                                <ng-container *ngIf="salesStatusVal == 8">
                                  <div class="formBtns text-right">
                                    <button
                                      class="pBtn"
                                      (click)="
                                        updateCommentsAndDisposition(lead, indx)
                                      "
                                      [disabled]="
                                        loading ||
                                        !addCommentForm.get('commentDate')
                                          ?.value ||
                                        !addCommentForm.get('commentTime')
                                          ?.value
                                      "
                                    >
                                      <i
                                        class="fa fa-spinner fa-spin"
                                        aria-hidden="true"
                                        *ngIf="loading"
                                      ></i>
                                      Add
                                    </button>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="salesStatusVal != 8">
                                  <div class="formBtns text-right">
                                    <button
                                      class="pBtn"
                                      (click)="
                                        updateCommentsAndDisposition(lead, indx)
                                      "
                                      [disabled]="loading"
                                    >
                                      <i
                                        class="fa fa-spinner fa-spin"
                                        aria-hidden="true"
                                        *ngIf="loading"
                                      ></i>
                                      Add
                                    </button>
                                  </div>
                                </ng-container>
                              </form>

                              <h5
                                class="modal-title text-left"
                                *ngIf="
                                  lead.oldComms && lead.oldComms.length > 0
                                "
                              >
                                Previous Comments
                              </h5>

                              <ul class="allNotes p-0" *ngIf="lead.oldComms">
                                <ng-container
                                  *ngFor="let comment of lead.oldComms"
                                >
                                  <li style="list-style-type: none">
                                    {{ comment.notes }}
                                  </li>
                                </ng-container>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="!isMyTab"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      gap: 10px;
                    "
                  >
                    <p class="roundedShape">
                      <span
                        [ngClass]="{
                          validBox: despositionArray.value == 0,
                          'disabledBox inValidBox': despositionArray.value != 0
                        }"
                      >
                        {{ showDisposition(lead.status, despositionArray) }}
                      </span>
                    </p>
                    <div *ngIf="lead.follow_up_date" class="followup-timer">
                      <span
                        class="actionUpdated small-text"
                        [ngClass]="{
                          'timer-green': getRemainingTime(lead.follow_up_date)
                            .isFuture,
                          'timer-red': !getRemainingTime(lead.follow_up_date)
                            .isFuture
                        }"
                      >
                        {{ getRemainingTime(lead.follow_up_date).text }}
                      </span>
                    </div>
                  </div>
                </td>

                <td *ngIf="!isMyTab">
                  <p>{{ lead.agent }}</p>
                </td>

                <!-- Assign Me Td -->
                <td *ngIf="!isMyTab">
                  <div class="pos-rel" *ngIf="lead.show_assign_to_me_button">
                    <a
                      href="javascript:;"
                      *ngIf="!lead.loading"
                      (click)="openAssignToMe_Sales_Modal(indx)"
                    >
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.1488 2.87993C16.9664 0.703647 13.8688 -0.384493 10.912 0.123306C10.8416 0.123306 10.8416 0.123306 10.7712 0.195848C10.2784 0.123306 9.7856 0.050763 9.2928 0.050763C6.688 0.050763 4.224 1.06636 2.3936 2.95247C2.112 3.24264 2.112 3.6779 2.3936 3.96807C2.6752 4.25824 3.0976 4.25824 3.3792 3.96807C4.928 2.29959 6.9696 1.42907 9.2224 1.42907C11.4752 1.42907 13.5168 2.29959 14.9952 3.89553C18.2336 7.23249 18.2336 12.6732 14.9952 16.0102C13.4464 17.6786 11.4048 18.5491 9.152 18.5491C6.9696 18.5491 4.8576 17.6061 3.3088 16.0102C3.0272 15.72 2.6048 15.72 2.3232 16.0102C2.0416 16.3003 2.0416 16.7356 2.3232 17.0257C4.1536 18.9119 6.6176 19.9275 9.2224 19.9275C9.7152 19.9275 10.208 19.8549 10.6304 19.8549C10.6304 19.8549 10.6304 19.8549 10.7008 19.8549C11.1936 19.9275 11.7568 20 12.2496 20C14.8544 20 17.3184 18.9119 19.1488 17.0257C22.9504 13.1084 22.9504 6.79723 19.1488 2.87993ZM18.1632 16.0827C17.3184 16.9532 16.3328 17.6061 15.2768 18.0413C15.6288 17.7512 15.9104 17.5335 16.192 17.1708C18.0224 15.2122 19.008 12.7457 19.008 10.0617C19.008 7.37757 18.0928 4.83858 16.192 2.95247C15.84 2.58976 15.488 2.29959 15.0656 2.00942C16.192 2.44467 17.3184 3.09756 18.1632 3.96807C21.4016 7.30503 21.4016 12.7457 18.1632 16.0827Z"
                          fill="#F07527"
                        />
                        <path
                          d="M3.3088 9.9891C3.3088 9.55384 3.0272 9.26367 2.6048 9.26367H0.704C0.2816 9.26367 0 9.55384 0 9.9891C0 10.4244 0.2816 10.7145 0.704 10.7145H2.6048C2.9568 10.7145 3.3088 10.4244 3.3088 9.9891Z"
                          fill="#F07527"
                        />
                        <path
                          d="M4.50555 9.98913C4.50555 10.4244 4.78715 10.7146 5.20955 10.7146H10.8416L7.67355 13.979C7.39195 14.2691 7.39195 14.7044 7.67355 14.9946C7.81435 15.1397 7.95515 15.2122 8.16635 15.2122C8.30715 15.2122 8.51835 15.1397 8.65915 14.9946L13.024 10.4969C13.3056 10.2068 13.3056 9.7715 13.024 9.48133L8.65915 4.98368C8.37755 4.69351 7.95515 4.69351 7.67355 4.98368C7.39195 5.27385 7.39195 5.70911 7.67355 5.99928L10.8416 9.2637H5.20955C4.78715 9.2637 4.50555 9.55387 4.50555 9.98913Z"
                          fill="#F07527"
                        />
                      </svg>
                    </a>

                    <!-- Loader for action -->
                    <i
                      class="fa fa-spinner fa-spin"
                      aria-hidden="true"
                      *ngIf="lead.loading"
                    ></i>

                    <!-- ProofReader Assign Me Model -->
                    <div class="paid-modal-m">
                      <div
                        class="modal fade"
                        [id]="'sales_assignme_modal' + indx"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel2"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog" role="document">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">
                              Are you sure you want to assign this lead to
                              yourself?
                            </h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a
                                  href="javascript:;"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  >NO</a
                                >
                                <a
                                  href="javascript:;"
                                  class="yes-btn bgOrange"
                                  (click)="assignToMe_Sales()"
                                  >YES</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <!----follow up-->
                <td *ngIf="isMyTab">
                  <div *ngIf="lead.follow_up_date" class="followup-timer">
                    <span
                      class="actionUpdated"
                      [ngClass]="{
                        'timer-green': getRemainingTime(lead.follow_up_date)
                          .isFuture,
                        'timer-red': !getRemainingTime(lead.follow_up_date)
                          .isFuture
                      }"
                    >
                      {{ getRemainingTime(lead.follow_up_date).text }}
                    </span>
                  </div>
                  <div *ngIf="!lead.follow_up_date">-</div>
                </td>
                <!-- Notes Td -->
                <td *ngIf="isMyTab">
                  <div class="pos-rel">
                    <a href="javascript:;" (click)="openNotesModal(indx)">
                      <svg
                        width="22"
                        height="27"
                        viewBox="0 0 22 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.9303 6.64509C21.8613 6.52396 21.7478 6.43557 21.6145 6.3994L17.714 5.33954C17.7668 5.18497 17.8057 5.0245 17.8305 4.86002C18.4192 4.67344 18.9102 4.27582 19.2205 3.73081C19.548 3.15553 19.635 2.48532 19.4654 1.84365C19.1155 0.519003 17.7679 -0.269856 16.4619 0.0849961C15.6222 0.313179 15.0015 0.959654 14.7578 1.74403C14.6594 1.75922 14.5617 1.77889 14.4656 1.80504C13.7696 1.99415 13.1879 2.44683 12.8276 3.07964C12.6756 3.34674 12.5712 3.63257 12.5147 3.92667L5.31364 1.96989C5.18031 1.93361 5.03845 1.95265 4.91906 2.02257C4.79962 2.0925 4.71246 2.20767 4.67679 2.34278L0.0177322 19.9761C-0.0179919 20.1112 0.000728179 20.2551 0.0696804 20.3763C0.138633 20.4974 0.252201 20.5858 0.385426 20.6219L3.73829 21.533V26.4727C3.73829 26.7639 3.9711 27 4.25829 27H21.1343C21.4215 27 21.6543 26.7639 21.6543 26.4727V8.28667L21.9823 7.04524C22.018 6.91019 21.9993 6.76622 21.9303 6.64509ZM16.7311 1.10378C17.4835 0.899695 18.2594 1.35374 18.4609 2.1166C18.5585 2.48617 18.5084 2.87218 18.3198 3.20346C18.1312 3.5348 17.8266 3.77179 17.4622 3.87082C17.0978 3.96975 16.7171 3.91902 16.3905 3.72775C16.0637 3.53643 15.83 3.22762 15.7324 2.85805C15.5308 2.09519 15.9788 1.30823 16.7311 1.10378ZM13.7283 3.60704C13.9383 3.238 14.271 2.96906 14.67 2.84318C14.6837 2.9391 14.7025 3.03519 14.7278 3.13101C14.8973 3.77268 15.3031 4.30899 15.8705 4.64117C16.1446 4.80169 16.4407 4.90442 16.7449 4.94919C16.5782 5.48703 16.1507 5.91962 15.5928 6.07123C14.71 6.31101 13.7992 5.77787 13.5626 4.88259C13.4481 4.4489 13.5069 3.99591 13.7283 3.60704ZM5.54675 3.1251L12.5262 5.0217C12.5357 5.06642 12.5463 5.11104 12.5581 5.15554C12.6371 5.45476 12.7627 5.72898 12.9244 5.97267L12.3794 6.52533C12.1764 6.73126 12.1764 7.06517 12.3794 7.27115C12.481 7.37409 12.614 7.42561 12.7471 7.42561C12.8802 7.42561 13.0133 7.37409 13.1148 7.27115L13.661 6.71728C14.0994 7.01539 14.6215 7.18351 15.1644 7.18351C15.3948 7.18351 15.629 7.15329 15.8619 7.09001C16.3766 6.95016 16.8236 6.66349 17.1637 6.2819L20.8431 7.28165L17.3268 20.5899L14.5689 19.8405C14.2915 19.7651 14.0064 19.9321 13.932 20.2134L13.1931 23.0102L1.1569 19.7397L5.54675 3.1251ZM16.3474 21.4157L14.388 22.5629L14.8021 20.9958L16.3474 21.4157ZM20.6143 25.9453H4.7783V21.8157L13.4262 24.1656C13.4705 24.1776 13.5157 24.1835 13.5608 24.1835C13.6513 24.1835 13.741 24.1596 13.8208 24.1129L17.9545 21.6926C18.074 21.6226 18.1611 21.5075 18.1968 21.3724L20.6142 12.2228V25.9453H20.6143Z"
                          fill="#075595"
                        />
                        <path
                          d="M6.43585 9.9475L16.7092 12.7392C16.7542 12.7514 16.7995 12.7573 16.8441 12.7573C17.0737 12.7573 17.2838 12.6019 17.3461 12.3663C17.4204 12.085 17.2558 11.7959 16.9784 11.7204L6.70505 8.92877C6.42753 8.85331 6.14251 9.02032 6.06815 9.30166C5.99379 9.58295 6.15842 9.87215 6.43585 9.9475Z"
                          fill="#075595"
                        />
                        <path
                          d="M5.89554 11.9944L16.1688 14.786C16.2139 14.7983 16.2592 14.8042 16.3038 14.8042C16.5334 14.8042 16.7435 14.6488 16.8057 14.4132C16.8801 14.1319 16.7155 13.8427 16.4381 13.7673L6.16475 10.9756C5.88738 10.9002 5.60216 11.0672 5.52785 11.3485C5.45354 11.6298 5.61817 11.919 5.89554 11.9944Z"
                          fill="#075595"
                        />
                        <path
                          d="M8.49942 13.8039L5.62362 13.0225C5.34621 12.9471 5.06104 13.1141 4.98673 13.3954C4.91237 13.6767 5.077 13.9658 5.35442 14.0412L8.23022 14.8227C8.2753 14.8349 8.32059 14.8408 8.36516 14.8408C8.59474 14.8408 8.80487 14.6854 8.86711 14.4498C8.94147 14.1685 8.77684 13.8794 8.49942 13.8039Z"
                          fill="#075595"
                        />
                        <path
                          d="M10.6255 14.4004H10.6251C10.3379 14.4004 10.1053 14.6365 10.1053 14.9277C10.1053 15.2189 10.3383 15.4551 10.6255 15.4551C10.9127 15.4551 11.1455 15.2189 11.1455 14.9277C11.1455 14.6365 10.9127 14.4004 10.6255 14.4004Z"
                          fill="#075595"
                        />
                      </svg>
                    </a>

                    <span class="actionUpdated" *ngIf="lead.noteUpdated"
                      >Updated</span
                    >

                    <div class="notesModal mainModal qa-lead">
                      <div
                        class="modal fade"
                        [id]="'notesModal' + indx"
                        tabindex="-1"
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog" role="document">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title text-left">Add Self Note</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <form [formGroup]="addCommentForm">
                                <div class="formItem shadowed w-100">
                                  <textarea
                                    [(ngModel)]="notes"
                                    formControlName="comment"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && f.comment.errors
                                    }"
                                    placeholder="Add self by typing here."
                                  ></textarea>
                                </div>
                                <div class="formBtns text-right">
                                  <button
                                    class="pBtn"
                                    (click)="updateSelfComments(lead, indx)"
                                    [disabled]="loading"
                                  >
                                    <i
                                      class="fa fa-spinner fa-spin"
                                      aria-hidden="true"
                                      *ngIf="loading"
                                    ></i>
                                    Add
                                  </button>
                                </div>
                              </form>

                              <h5
                                class="modal-title text-left"
                                *ngIf="lead.self_comments != ''"
                              >
                                Previous Self Note
                              </h5>
                              <ul
                                class="allNotes p-0"
                                *ngIf="lead.self_comments != ''"
                              >
                                <li style="list-style-type: none">
                                  {{ lead.self_comments }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <!--Comments Td -->
                <td>
                  <div class="pos-rel" *ngIf="lead.view_leads_comments">
                    <a
                      href="javascript:;"
                      (click)="showComments(lead, indx)"
                      *ngIf="loader != lead.id"
                    >
                      <svg
                        width="25"
                        height="20"
                        viewBox="0 0 25 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.873 0H5.12695C2.29988 0 0 2.23443 0 4.98105V12.6743C0 14.8659 1.48106 16.7747 3.6272 17.3857L6.10332 19.7915C6.24084 19.925 6.427 20 6.62136 20C6.81553 20 7.00188 19.925 7.13921 19.7915L9.41067 17.5845H19.873C22.7001 17.5845 25 15.3501 25 12.6035V4.98105C25 2.23443 22.7001 0 19.873 0ZM23.5352 12.6035C23.5352 14.5653 21.8924 16.1614 19.873 16.1614H9.1074C8.91323 16.1614 8.72688 16.2364 8.58955 16.3698L6.62136 18.282L4.52518 16.2455C4.43115 16.1541 4.31328 16.0893 4.18415 16.0581C2.58312 15.671 1.46484 14.2796 1.46484 12.6743V4.98105C1.46484 3.01921 3.10764 1.42316 5.12695 1.42316H19.873C21.8924 1.42316 23.5352 3.01921 23.5352 4.98105V12.6035Z"
                          fill="#00A5DC"
                        />
                        <path
                          d="M17.1506 6.82312H7.84961C7.44506 6.82312 7.11719 7.14185 7.11719 7.5347C7.11719 7.92774 7.44506 8.24628 7.84961 8.24628H17.1506C17.5552 8.24628 17.883 7.92774 17.883 7.5347C17.883 7.14185 17.5552 6.82312 17.1506 6.82312Z"
                          fill="#00A5DC"
                        />
                        <path
                          d="M17.1506 9.33826H7.84961C7.44506 9.33826 7.11719 9.6568 7.11719 10.0498C7.11719 10.4429 7.44506 10.7614 7.84961 10.7614H17.1506C17.5552 10.7614 17.883 10.4429 17.883 10.0498C17.883 9.6568 17.5552 9.33826 17.1506 9.33826Z"
                          fill="#00A5DC"
                        />
                      </svg>
                    </a>

                    <!-- Action Loader -->
                    <i
                      class="fa fa-spinner fa-spin"
                      aria-hidden="true"
                      *ngIf="loader == lead.id"
                    ></i>

                    <!-- Comments Modal -->
                    <div class="comment-modal-m">
                      <div
                        class="modal fade"
                        [id]="'comment_modal' + indx"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel1"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog" role="document">
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5
                              class="modal-title"
                              id="exampleModalLabel1"
                              [ngClass]="{
                                'w-100': qaComments.length == 0 || isMyTab
                              }"
                              *ngIf="agentComments.length > 0"
                            >
                              Agent Comments
                            </h5>
                            <h5
                              class="modal-title qa-comment"
                              id="exampleModalLabel1"
                              [ngClass]="{ 'w-100': agentComments.length == 0 }"
                              *ngIf="qaComments.length > 0 && !isMyTab"
                            >
                              Q/A Comments
                            </h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div
                                class="comments-sub"
                                [ngClass]="{
                                  'w-100': qaComments.length == 0 || isMyTab
                                }"
                                *ngIf="agentComments.length > 0"
                              >
                                <ng-container
                                  *ngFor="let comment of agentComments"
                                >
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{
                                      agentSearch(comment.user_id, agents)
                                    }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{
                                      comment.date | customDatePipe : "dateTime"
                                    }}</span>
                                  </div>
                                </ng-container>
                              </div>

                              <div
                                class="comments-sub qa-box"
                                [ngClass]="{
                                  'w-100': agentComments.length == 0
                                }"
                                *ngIf="qaComments.length > 0 && !isMyTab"
                              >
                                <ng-container
                                  *ngFor="let comment of qaComments"
                                >
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{
                                      agentSearch(comment.user_id, qa)
                                    }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{
                                      comment.date | customDatePipe : "dateTime"
                                    }}</span>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- floating alert starts -->
<ng-container *ngIf="leads.alertMessage && leads.data && leads.data.length > 0">
  <div class="floatingAlert" *ngIf="floatingAlert">
    <button type="button" class="close" (click)="closeFloatingAlert()">
      <i class="fa fa-times"></i>
    </button>
    <p>{{ leads.alertMessage }}</p>
  </div>
</ng-container>
<!-- floating alert ends -->
